export const FONT_SIZE = {
  MINI: '10px',
  SMALL: '13px',
};
